import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

/**
 * Generates message for hreflang tags section
 * @param {Object} data - The hreflang data object
 * @returns {string|null} - Message for empty state or null if data exists
 */
const generateMessage = (data) => {
  const tags = data?.tags || [];
  if (!tags || tags?.length === 0) {
    return 'No Hreflang Tags were identified.';
  }
  return null;
};

/**
 * Transforms the hreflang criteria from WooRank API response
 * @param {Object} hreflangCriteria - The hreflang criteria object from the API
 * @returns {Object} - Transformed hreflang tags data for React components
 */
export const transformHreflangTags = (hreflangCriteria) => {
  // Handle missing criteria - use 'neutral' status (maps to 'info' icon)
  if (!hreflangCriteria) {
    return {
      status: getStatus('neutral'),
      iconType: getIconType('neutral'),
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'No Hreflang Tags were identified.',
      data: null,
    };
  }

  const data = hreflangCriteria?.data || {};
  const tags = data?.tags || [];
  const wooRankStatus = hreflangCriteria?.status || 'neutral';
  const importance = hreflangCriteria?.importance || 0;
  const solvability = hreflangCriteria?.solvability || 0;

  const isEmpty = !tags || tags?.length === 0;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: generateMessage(data),
    data: isEmpty ? null : {
      tags: (tags || []).map((item) => ({
        href: item?.href || '',
        hreflang: item?.hreflang || '',
        isCorrect: item?.isCorrect ?? false,
        source: item?.source || '',
      })),
    },
  };
};

export default transformHreflangTags;

